const extractMessage = (error) => {
  if (!error) {
    return '';
  }

  if (typeof error === 'string') {
    return error;
  }

  if (typeof error.shortMessage === 'string' && error.shortMessage.trim()) {
    return error.shortMessage;
  }

  if (typeof error.message === 'string' && error.message.trim()) {
    return error.message;
  }

  if (error.cause && typeof error.cause.message === 'string') {
    return error.cause.message;
  }

  return String(error);
};

const normalizeWalletError = (error, fallbackMessage = 'Transaction failed. Please try again.', options = {}) => {
  const message = extractMessage(error);
  const lower = message.toLowerCase();
  const network = options.network ? String(options.network).toLowerCase() : null;
  const wallet = options.wallet ? String(options.wallet).toLowerCase() : null;

  if (lower.includes('invalid amount format') || lower.includes('amount parsing error')) {
    return 'Invalid amount format. Please refresh to get a new quote.';
  }

  if (lower.includes('decimal places')) {
    return 'Amount has too many decimal places for this token.';
  }

  if (lower.includes('no transaction hash')) {
    return 'Transaction submitted without a hash. Please try again.';
  }

  if (
    error?.code === 4001 ||
    lower.includes('user rejected') ||
    lower.includes('user denied') ||
    lower.includes('rejected the request') ||
    lower.includes('user cancelled')
  ) {
    if (wallet === 'phantom' || network === 'solana') {
      return 'Transaction was cancelled in Phantom.';
    }
    return 'Transaction was cancelled in your wallet.';
  }

  if (network === 'solana' || wallet === 'phantom') {
    if (lower.includes('transaction simulation failed')) {
      return 'Transaction simulation failed. Please check your balance and try again.';
    }

    if (lower.includes('blockhash not found')) {
      return 'Network error. Please try again.';
    }

    if (lower.includes('signature verification failed')) {
      return 'Transaction signature was rejected. Please try again.';
    }

    if (lower.includes('transaction was not confirmed') || lower.includes('confirmation timeout') || lower.includes('timed out')) {
      return 'Transaction confirmation timed out. Please check the explorer.';
    }

    if (lower.includes('account does not exist') || lower.includes('could not find account')) {
      return 'Token account not found. Please ensure your wallet holds this token.';
    }

    if (lower.includes('token account') && lower.includes('not found')) {
      return 'Token account not found. Please ensure your wallet holds this token.';
    }

    if (lower.includes('attempt to debit an account but found no record of a prior credit')) {
      return 'Insufficient funds in your wallet to complete this transaction.';
    }

    if (lower.includes('insufficient funds for fee')) {
      return 'Insufficient SOL for network fees.';
    }

    if (lower.includes('custom program error') || lower.includes('instruction error')) {
      return 'Transaction failed on-chain. Please try again.';
    }
  }

  if (lower.includes('insufficient funds') || lower.includes('insufficient balance') || (lower.includes('gas') && lower.includes('insufficient'))) {
    return 'Insufficient funds for gas. Please add gas and try again.';
  }

  if (lower.includes('nonce too low') || lower.includes('replacement fee too low') || lower.includes('already known')) {
    return 'Transaction could not be submitted. Please try again.';
  }

  if (lower.includes('wrong network') || lower.includes('unsupported chain') || lower.includes('chainid')) {
    return 'Your wallet is connected to the wrong network.';
  }

  if (lower.includes('execution reverted') || lower.includes('reverted')) {
    return 'Transaction failed on-chain. Please try again.';
  }

  if (
    lower.includes('request arguments') ||
    lower.includes('contract call') ||
    lower.includes('docs:') ||
    lower.includes('version:') ||
    lower.includes('viem@')
  ) {
    return fallbackMessage;
  }

  return fallbackMessage;
};

export default normalizeWalletError;
